/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimOrganizationsResponseMeta
 */
export interface ClaimOrganizationsResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganizationsResponseMeta
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganizationsResponseMeta
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof ClaimOrganizationsResponseMeta
     */
    total: number;
}

/**
 * Check if a given object implements the ClaimOrganizationsResponseMeta interface.
 */
export function instanceOfClaimOrganizationsResponseMeta(value: object): value is ClaimOrganizationsResponseMeta {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function ClaimOrganizationsResponseMetaFromJSON(json: any): ClaimOrganizationsResponseMeta {
    return ClaimOrganizationsResponseMetaFromJSONTyped(json, false);
}

export function ClaimOrganizationsResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimOrganizationsResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'offset': json['offset'],
        'total': json['total'],
    };
}

export function ClaimOrganizationsResponseMetaToJSON(json: any): ClaimOrganizationsResponseMeta {
    return ClaimOrganizationsResponseMetaToJSONTyped(json, false);
}

export function ClaimOrganizationsResponseMetaToJSONTyped(value?: ClaimOrganizationsResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'offset': value['offset'],
        'total': value['total'],
    };
}

